const NotFoundPlugin = () => {
    return <p> Справочник не настроен </p>;
};

export { NotFoundPlugin };
